export default {
  data() {
    return {
      rulePendencies: null,
      ruleRetrying: false,
      guardAction: null,
      guardSuccess: null,
    }
  },

  methods: {
    runGuarded(action, onSuccess = null) {
      this.guardAction = action
      this.guardSuccess = onSuccess

      return this.executeGuarded({})
    },

    async executeGuarded(options) {
      this.ruleRetrying = true

      try {
        const result = await this.guardAction(options)

        this.rulePendencies = null

        if (this.guardSuccess) await this.guardSuccess(result)

        return true
      } catch (e) {
        const data = (e.response && e.response.data) || {}

        if (e.response && e.response.status === 422 && data.allowed === false) {
          this.rulePendencies = data
          return false
        }

        throw e
      } finally {
        this.ruleRetrying = false
      }
    },

    closeRulePendencies() {
      this.rulePendencies = null
    },
  },
}
